import * as D from '../deps';

import * as KruxWorkers from './workers';

export default [
  {
    actionType: D.Constants.Listener.ListenerActions.LISTENER_AUTHENTICATED,
    handler: KruxWorkers.onListenerAuthenticated,
    concur: 'takeEvery',
  },
];
